import { hmsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showSuccessMessage, showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

//schedule interview
export const get_generated_hms_client_token_action =
  (id) => async (dispatch) => {
    dispatch({
      type: hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.hmsGenerateClientToken.replace(":id", id)}`
      );
      if (response.status) {
        dispatch({
          type: hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_FAILURE,
        payload: e?.msg,
      });
      showWarningMessage(e?.msg);
    }
  };

//schedule interview
export const unregistered_user_get_generated_hms_client_token_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        `${config.common.unregisterUserhmsGenerateClientToken.replace(
          ":id",
          id
        )}`,
        data
      );
      if (response.status) {
        dispatch({
          type: hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hmsConstants.GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const get_hms_room_details_action = (id, data) => async (dispatch) => {
  dispatch({
    type: hmsConstants.GET_HMS_ROOM_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.hmsRoomDetails.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: hmsConstants.GET_HMS_ROOM_DETAILS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hmsConstants.GET_HMS_ROOM_DETAILS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//schedule interview
export const create_hms_room_question_action = (data) => async (dispatch) => {
  dispatch({
    type: hmsConstants.CREATE_HMS_ROOM_QUESTION_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.common.addHmsMeetQuestion,
      data
    );
    if (response.status) {
      dispatch({
        type: hmsConstants.CREATE_HMS_ROOM_QUESTION_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hmsConstants.CREATE_HMS_ROOM_QUESTION_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//schedule interview
export const update_hms_room_question_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: hmsConstants.UPDATE_HMS_ROOM_QUESTION_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.common.updateHmsMeetQuestion.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: hmsConstants.UPDATE_HMS_ROOM_QUESTION_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("updated successfully.")
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hmsConstants.UPDATE_HMS_ROOM_QUESTION_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
    }
  };

//schedule interview
export const delete_hms_room_question_action = (id) => async (dispatch) => {
  dispatch({
    type: hmsConstants.DELETE_HMS_ROOM_QUESTION_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.delete(
      config.common.updateHmsMeetQuestion.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: hmsConstants.DELETE_HMS_ROOM_QUESTION_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hmsConstants.DELETE_HMS_ROOM_QUESTION_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//schedule interview
export const get_hms_room_questions_action = (id) => async (dispatch) => {
  dispatch({
    type: hmsConstants.GET_HMS_ROOM_QUESTION_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.getHmsRoomQuestionsList.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: hmsConstants.GET_HMS_ROOM_QUESTION_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hmsConstants.GET_HMS_ROOM_QUESTION_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//schedule interview
export const create_hms_room_question_rating_action =
  (data) => async (dispatch) => {
    dispatch({
      type: hmsConstants.CREATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST,
    });
    try {
      const response = {};
      await axiosInstance.post(config.common.hmsRoomQuestionRating, data);
      if (response.status) {
        dispatch({
          type: hmsConstants.CREATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hmsConstants.CREATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const update_hms_room_question_rating_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: hmsConstants.UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.common.updateHmsRoomQuestionRating.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: hmsConstants.UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hmsConstants.UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const get_hms_room_question_rating_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: hmsConstants.GET_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST,
    });
    try {
      const response = {};
      // await axiosInstance.put(
      //   config.common.getHmsRoomQuestionsList.replace(":id", id), data
      // );
      if (response.status) {
        dispatch({
          type: hmsConstants.GET_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hmsConstants.GET_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
